export const products = [{
        id: 1,
        name: 'Silk-blend Kaftan',
        href: '#',
        imageSrc: 'https://i.pinimg.com/originals/b9/67/e3/b967e31004de682f8ef72ca8662c6797.jpg',
        imageAlt: "Front of men's Basic Tee in black.",
        price: 135,
        type: ['Women', 'Accessories'],
        color: 'Black',
        stock: false,
        category: 'cloth',
        for: 'women',
        animation: 'fade-right'
    },
    {
        id: 2,
        name: 'Paper Straw Shopper',
        href: '#',
        imageSrc: 'https://i.pinimg.com/736x/46/6c/b6/466cb62dbd4a4b807d5570eeff965804.jpg',
        imageAlt: "Front of men's Basic Tee in black.",
        price: 89,
        color: 'Black',
        type: ['Accessories', 'Men'],
        stock: true,
        category: 'bag',
        for: 'every',
        animation: 'fade-down'
    },
    {
        id: 3,
        name: 'Sandals with Lacing',
        href: '#',
        imageSrc: 'https://i.pinimg.com/736x/fa/ab/bc/faabbc7750e9eec61a10c1fd6e617972---other-stories-ss-.jpg',
        imageAlt: "Front of men's Basic Tee in black.",
        price: 135,
        color: 'Black',
        type: ['Men', 'Clothing'],
        stock: true,
        category: 'shoes',
        for: 'men',
        animation: 'fade-down'
    },
    {
        id: 4,
        name: 'Backpack',
        href: '#',
        imageSrc: 'https://cdn.shopify.com/s/files/1/2019/6373/products/ism-large-backpack-black-front_d0c9815b-e286-4fc9-8a8a-6eacf6feb584_1014x.png?v=1606128264',
        imageAlt: "Front of men's Basic Tee in black.",
        price: 95,
        color: 'Black',
        type: ['Women', 'Accessories', 'Men'],
        stock: false,
        category: 'bag',
        for: 'every',
        animation: 'fade-right'
    },
    {
        id: 5,
        name: 'Briella Linen Blend',
        href: '#',
        imageSrc: 'data:image/jpeg;base64,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',
        imageAlt: "Front of men's Basic Tee in black.",
        price: 95,
        color: 'Black',
        type: ['Women', 'Accessories', 'Men'],
        stock: true,
        category: 'cloth',
        for: 'women',
        animation: 'fade-right'
    },
    {
        id: 6,
        name: 'Bucket Bag',
        href: '#',
        imageSrc: 'https://lp2.hm.com/hmgoepprod?set=quality%5B79%5D%2Csource%5B%2Fac%2F72%2Fac72728df0e79df59f1be95b95ec2f8f9f4273e2.jpg%5D%2Corigin%5Bdam%5D%2Ccategory%5Bladies_jumpsuits_long%5D%2Ctype%5BDESCRIPTIVESTILLLIFE%5D%2Cres%5Bm%5D%2Chmver%5B1%5D&call=url[file:/product/main]',
        imageAlt: "Front of men's Basic Tee in black.",
        price: 85,
        color: 'Black',
        type: ['Women', 'Accessories', 'Men'],
        stock: false,
        category: 'bag',
        for: 'every',
        animation: 'fade-up'
    },
    {
        id: 7,
        name: 'Mens Jacket',
        href: '#',
        imageSrc: 'https://connor.imgix.net/Connor/Products/C17CJ108_BLK_1.png?w=400&h=566&bg=f1f1f1&cs=tinysrgb&fm=jpg&rect=440,0,2120,3000',
        imageAlt: "Front of men's Basic Tee in black.",
        price: 45,
        color: 'Black',
        type: ['Women', 'Accessories', 'Men'],
        stock: true,
        category: 'jacket',
        for: 'men',
        animation: 'fade-up'
    },
    {
        id: 8,
        name: 'Womenst Fasion',
        href: '#',
        imageSrc: 'https://i.pinimg.com/736x/a9/94/7a/a9947a21d05093a3e83df149a8c9c247.jpg',
        imageAlt: "Front of men's Basic Tee in black.",
        price: 97,
        color: 'Black',
        type: ['Women', 'Accessories', 'Men'],
        stock: true,
        category: 'cloth',
        for: 'women',
        animation: 'fade-left'
    },
    {
        id: 9,
        name: 'Silk-blend Kaftan',
        href: '#',
        imageSrc: 'https://i.pinimg.com/originals/b9/67/e3/b967e31004de682f8ef72ca8662c6797.jpg',
        imageAlt: "Front of men's Basic Tee in black.",
        price: 135,
        type: ['Women', 'Accessories', 'Men'],
        color: 'Black',
        stock: false,
        category: 'cloth',
        for: 'women',
        animation: 'fade-left'
    },
    {
        id: 10,
        name: 'Paper Straw Shopper',
        href: '#',
        imageSrc: 'https://i.pinimg.com/736x/46/6c/b6/466cb62dbd4a4b807d5570eeff965804.jpg',
        imageAlt: "Front of men's Basic Tee in black.",
        price: 89,
        color: 'Black',
        type: ['Accessories', 'Men'],
        stock: true,
        category: 'bag',
        for: 'every',
        animation: 'fade-right'

    },
    // More products...
]